import { Injector, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateLoader, TranslateModule, TranslateParser } from '@ngx-translate/core';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { AppComponent } from './app.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { CustomTranslateLoader } from '@shared/localization/custom-translate-loader';
import { CustomTranslateParser } from '@shared/localization/custom-translate-parser';
import { AppRoutingModule } from './app-routing.module';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { BsDatepickerConfig, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { BsDropdownConfig } from 'ngx-bootstrap/dropdown';
import { TabsetConfig } from 'ngx-bootstrap/tabs';
import { HotkeyModule } from 'angular2-hotkeys';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TruncateModule } from '@yellowspot/ng-truncate';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { VirtualScrollerModule } from '@iharbeck/ngx-virtual-scroller';
import { SharedModule } from '@shared/shared.module';
import { ApplicationService } from '@shared/application/application.service';
import { ServiceUnavailableInfoComponent } from '@login/service-unavailable-info/service-unavailable-info.component';
import { SvgIconComponent } from '@shared/svg-icon/svg-icon.component';

export let AppInjector: Injector;

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-center',
      preventDuplicates: true,
    }),
    FormsModule,
    ReactiveFormsModule,
    AccordionModule.forRoot(),
    BsDatepickerModule.forRoot(),
    ModalModule.forRoot(),
    HotkeyModule.forRoot(),
    CollapseModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateLoader,
        deps: [ HttpClient, ApplicationService ],
      },
      parser: {
        provide: TranslateParser,
        useClass: CustomTranslateParser,
      },
    }),
    HttpClientModule,
    AppRoutingModule,
    TruncateModule,
    VirtualScrollerModule,
    SharedModule,
    ServiceUnavailableInfoComponent,
    SvgIconComponent,
  ],
  providers: [
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy,
    },
    { provide: 'virtualScroller.scrollAnimationTime', useValue: 0 },
    { provide: 'virtualScroller.stripedTable', useValue: true },
    ToastrService,
    BsModalService,
    BsDatepickerConfig,
    BsDropdownConfig,
    TabsetConfig
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(private injector: Injector) {
    AppInjector = this.injector;
  }
}
